export const notification = (d) => {
    if (_notificationHandler) {
        _notificationHandler.addNotification({
            title: d.title,
            message: d.subtitle,
            level: d.theme || 'success',
            position: 'tr',
            action: d.button,
        });
    }
};
export const attachNotificationHandler = (ref) => {
    _notificationHandler = ref;
};
let _notificationHandler;
//# sourceMappingURL=notifications.js.map